// @flow
import modularui from "../_modularui/ModularUIConnector";

import type { ModularUIConnector } from "../_modularui/types";

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useModelCatalog' instead
 */
export const connectModelCatalog: ModularUIConnector = modularui(
  "ModelCatalog",
  ({ match }) => match.url,
  {
    propName: "modelcatalog",
  },
);
